import { Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'happy-step',
    template: '<ng-template><ng-content></ng-content></ng-template>',
    encapsulation: ViewEncapsulation.None
})
export class HappyStepComponent {

    @ViewChild(TemplateRef) content: TemplateRef<any>;
    @Input() stepFormGroup: FormGroup;

    isDirty(): boolean {
        return this.stepFormGroup && this.stepFormGroup.dirty;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-stepper/happy-step/happy-step.component.ts